import { Modal, CloseButton } from "react-bootstrap";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}

export const ModalWrapper = (props: Props) => {
  const { open, handleClose, children, ...divProps } = props;

  return (
    <Modal show={open} animation={true} centered className="modal-wrapper" onHide={handleClose} {...divProps}>
      <Modal.Body className="modal-wrapper-body">
        <span className="modal-close-button" />
        {children}
        <CloseButton className="modal-close" onClick={handleClose} />
      </Modal.Body>
    </Modal>
  );
};
